<template>
  
  <body :style="{backgroundImage:`url(bg.jpg)`}">
    <Header></Header>
    <div class="container" >
      <div class="header">
        <img src="Netflix-Logo.png" height="150px" width="200px" class="logo">

      </div>
      <div class="sub-container">
        <span class="see">Storytelling with Netflix</span>
        <p class="watch"> </p>

      </div>
      <router-link to="/line_chart">
      <!-- <img src="lufei.jpg" height="50px" width="50px" class='position'> -->
      <button class='explore'>Let's Explore</button>
      </router-link>
      
    </div>
  </body>
  
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header'

export default {
  name: "Home",
  components: {
    Header
  },
};
</script>

<style scoped>
body
{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.logo
{
  margin-top: 20px;
}
.container
{
  height: 100vh;
  width: 100%;
  text-align: center;
}
.position
{
  /* position: absolute;
  top: 8%;
  left: 90%; */
  margin-top: 60px;
}
.position:hover
{
  /* opacity: 1; */
}

.sub-container
{
  margin-top: 40px;
}

.see
{
  font-size: 80px;
  font-weight: 700;
  color: #fff;
  font-family: Helvetica;
}

.watch
{
  margin-top: 10px;
  font-size: 40px;
  font-weight: 300;
  color: #fff;
  font-family: Helvetica;
}

.explore
{
  margin-top: 65px;
  border: 0;
  background: #e50815;
  padding: 20px 80px;
  font-size: 40px;
  color: #fff;
  font-family: Helvetica;
  letter-spacing: 2px;
  word-spacing: 5px;
  opacity: 0.9;
}

.explore:hover
{
  opacity: 1;
}

</style>
